import type { SearchStore } from '@/scopes/search/search/infrastructure/store/store'

import { useDependencies } from '@/scopes/common/infrastructure/dependencies'
import { identity } from 'ramda'
import { useStore } from 'zustand'

export function useSearchStore() {
  const { searchStore } = useDependencies()
  return useStore(searchStore, identity<SearchStore>)
}

export function useSearchStoreSelector<T, A extends unknown[] = []>(selector: (state: SearchStore, ...args: A) => T, ...args: A): T {
  const store = useSearchStore()
  return selector(store, ...args)
}
